React = require 'react'
ReactBacon = require 'react-bacon'
R = require 'ramda'
moment = require 'moment'
{Icon }= require 'react-fa'
createReactClass = require 'create-react-class'

orderStore = require 'stores/order'
rdsOrderStore = require 'stores/rds-order'
ordersStore = require 'stores/orders'
uiStore = require 'stores/ui'
userStore = require 'stores/user'

{Row, Col, Button} = require 'reactstrap'
import PaymentsInfo from './v5/payments'

orderUtils = require './components/utils'

{ toID, shortID, touple, booleanOf, currency, percent } = orderUtils
{ formatTimeWithOffset, pairsToTable, pairsToList, googleMapsLinkToAddress } = orderUtils
{ UserIs, UserIsNot, UserWants } = orderUtils

import { AuditService, AuditResource } from 'api/audit'

OrderInfo               = require './sections/info'
CustomerInfo            = require './sections/customer'
RestaurantInfo          = require './sections/restaurant'
OrderItems              = require './sections/items'
OrderEvents             = require './sections/events'
RestaurantNotifications = require './sections/notifications'
OrderTotal              = require './sections/total'
OrderHeading            = require './sections/heading'
DeliveryInfo            = require './sections/delivery'

OrderToolbar            = require './toolbar'

Order = require 'models/order'

OrderPage = createReactClass
  displayName: 'OrderPage'
  mixins: [ReactBacon.BaconMixin, require('./loader')]

  shouldComponentUpdate: (p, s) ->
    !s.reloading or !!s.error

  render: ->
    if !@state.order or !@state.restaurant
      return @renderLoadingWithErrors()

    @renderOrder(@state.order, @getLocale())

  onPinTab: ->
    ordersStore.pin @state.order.id

  renderOrder: (order, locale) ->
    state = if @state.orderState then @state.orderState.state else "n/a"
    # usesPayments2 = !(@props.paymentsQuery.loading && @props.paymentsQuery.data && @props.paymentsQuery.data.order != null)
    usesPayments2 = R.path(['paymentsQuery', 'data', 'order'], @props) != null
  
    <Col key={order.id} md={9} sm={9} style={paddingTop: "10px"}>
      <Row>
        <Col xs={12}>
          {@_renderError()}
          <OrderHeading key={R.join("-", [@state.order.id, @state.restaurant.permalink])} order={@state.order} gqlOrder={@props.order} rdsOrder={@state.rdsOrder} restaurant={@state.restaurant} state={state} locale={locale}/>
          <OrderToolbar key={@state.order.id} model={orderStore} rdsOrder={@state.rdsOrder} order={@state.order} actions={@state.actions} notifications={@state.notifications} restaurant={@state.restaurant} usesPayments2={usesPayments2}>
            <Button onClick={@onPinTab}> <Icon fixedWidth name="thumb-tack"/> </Button>
          </OrderToolbar>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <OrderInfo key="order_info_#{@state.order.id}" order={@state.order} gqlOrder={@props.order} locale={locale} restaurant={@state.restaurant} events={@state.events} />
          <RestaurantInfo key={@state.restaurant.permalink} restaurant={@state.restaurant} channel={@state.channel} order={@state.order} />
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <RestaurantNotifications order={@state.order} locale={locale} restaurant={@state.restaurant} notifications={@state.notifications}/>
          <OrderTotal order={@state.order} locale={locale} restaurant={@state.restaurant} />
          <OrderItems order={@state.order} locale={locale} restaurant={@state.restaurant} /> 
        </Col>
        <Col xs={12} sm={12} style={overflowWrap: 'anywhere'}>
          { if usesPayments2
              <AuditService resourceType={'order'} resourceId={@state.order.id}>
                <PaymentsInfo
                  orderId={@state.order.id} 
                  data={@state.order} 
                  order={@props.paymentsQuery.data.order}
                  reload={() => @props.paymentsQuery.refetch({ order_id: @state.order.id }) } 
                  skipAdjustments={false}/>
              </AuditService>
            else 
              <span></span>
          }
        </Col>
        <Col xs={12} sm={12} style={overflowWrap: 'anywhere'}>
          { if userStore.hasAnyRole('config', 'restaurant_admin', 'restaurant', 'restaurant_staff')
              <UserWants name="show-order-events">
                <OrderEvents order={@state.order} locale={locale} restaurant={@state.restaurant} events={@state.events}/>
              </UserWants>
            else
              <></>
          }
        </Col>
      </Row>
    </Col>

module.exports = OrderPage
